import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-button-primary",
  templateUrl: "./button-primary.component.html",
  styleUrls: ["./button-primary.component.css"],
})
export class ButtonPrimaryComponent {
  @Input() label: string = "";
  @Input() type: "button" | "submit" | "reset" = "button";
  @Input() id: "";
  @Input() btnStyle: "gts-btn-primary-outline" | "gts-btn-primary";
  @Input() disabled: boolean = false;
  @Input() outline: boolean = false;
  @Input() primary: boolean = false;
  @Input() warning: boolean = false;
  @Input() fullWidth: boolean = false;
  @Input() outlineDanger: boolean = false;
  @Input() outlineMainGray: boolean = false;
  @Input() danger: boolean = false;
  @Input() dangerText: boolean = false;
  @Input() success: boolean = false;
  @Input() info: boolean = false;
  @Input() infoChip: boolean = false;
  @Input() outlineSmall: boolean = false;
  @Input() borderRight: boolean = false;
  @Input() isNextStepper: boolean = false;
  @Input() iconOnly = false;
  // @Input() size: "sm" | "md" | "lg" = "md";
  @Input() iconLeft?: string;
  @Input() iconRight?: string;
  @Input() iconLeftImg?: string;
  @Input() iconRightImg?: string;
  @Input() iconLeftCustom?: string;
  @Input() iconRightCustom?: string;
  @Input() iconOnlyName?: string;
  @Input() routerLink: any[] | string | null = null;
  @Output() clickBtn = new EventEmitter<Event>();

  handleClick(event: Event) {
    if (!this.disabled) {
      this.clickBtn.emit(event);
    }
  }

  get classes(): string {
    return `
      ${this.btnStyle} 
    `;
  }
}
